var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip)?_c('button',{staticClass:"btn-help tooltip",attrs:{"tabindex":"-1","type":"button","data-tooltip":_vm.tooltip}},[_c('span',{staticClass:"icon-help"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }